<!-- Navbar for Special Routes (Enquiry/Prospective) -->
<nav v-if="$route.name === 'enquiry_landing_page' || $route.name === 'prospective_applicant'" class="navbar navbar-expand-lg  sticky-top px-0">
  <div class="container-fluid px-0 py-0">
    <div class="d-flex align-items-center ms-3">
      <a class="border-0 d-flex align-items-center me-3" id="navbar_logo">
        <img :src="$clientLogo" alt="Logo" class="logo-img mt-2" width="120px">
      </a>
    </div>

    <!-- Simplified navbar for enquiry landing page -->
    <div class="d-flex align-items-center ms-auto">
      <a class="nav-link me-3 text-xxs btn btn-sm p-2 btn-primary-dark rounded-small" href="/">Login</a>
    </div>
  </div>
</nav>

<!-- Navbar for Company Management Page (Any Role) -->
<nav v-else-if="should_show_navbar" class="navbar navbar-expand-lg navbar-light px-0">
  <div class="container-fluid px-0 py-0">
    <div class="d-flex align-items-center ms-3">

      <!-- Add hamburger here -->
      <button
        v-if="!hide_hamburger"
        class="d-flex d-md-none align-items-center justify-content-center btn p-0 me-3 border-0 bg-transparent"
        @click="$emit('toggle-sidebar')"
        aria-label="Open menu"
      >
        <i class="bi bi-list fs-3"></i>
      </button>

      <a class="border-0 d-flex align-items-center me-3 d-none d-md-flex" id="navbar_logo">
        <img :src="$clientLogo" alt="Logo" class="logo-img mt-2" width="150px">
      </a>
    </div>

    <!-- Navbar Items on company management -->
    <div class="d-flex align-items-center ms-auto">
      <a v-if="user_role === 'System Admin'" class="d-none nav-link me-3 text-xxs" href="/user_management">Trust Manager Administrator Dashboard</a>
      <a class="nav-link me-3 text-xs text-white
      " href="/" @click.prevent="logout">
        <i class="bi bi-box-arrow-right fs-3"></i>
      </a>
    </div>
  </div>
</nav>

<!-- Standard Navbar for All Other Authenticated Roles -->
<nav v-else class="navbar navbar-expand-lg sticky-top px-0">
  <div class="container-fluid d-flex align-items-center justify-content-between">

    <!-- LEFT SECTION -->
    <div class="d-flex align-items-center">
      <!-- Hamburger: mobile only, in navbar -->
      <button
        v-if="!hide_hamburger"
        class="d-flex d-md-none align-items-center justify-content-center btn p-0 me-2 border-0 bg-transparent"
        @click="$emit('toggle-sidebar')"
        aria-label="Open menu"
      >
        <i class="bi bi-list fs-3 text-white"></i>
      </button>

      <a href="#" class="border-0 d-flex align-items-center me-3" id="sidebar_toggle">
        <span class="d-none" @click="$emit('toggle-sidebar')">
          <i class="bi bi-list fs-5 me-2"></i>
        </span>

        <!-- Entity role goes to trusts -->
        <i v-if="user_role === 'Entity'"
          class="bi bi-house fs-5 text-white fw-bold d-none d-md-inline"
          @click="go_to_home_for_trusts"
          role="button">
        </i>

        <!-- All other non-Lead roles go to home -->
        <i v-else-if="user_role !== 'Lead'"
          class="bi bi-house fs-5 text-white fw-bold d-none d-md-inline"
          @click="go_to_home"
          role="button">
        </i>


        <!-- Project Badge (hidden on configure_company_management) -->
        <span
          v-if="user_role === 'System Admin' && $route.name !== 'configure_company_management'"
          class="project-badge rounded-lg text-white ms-2 ms-md-5 d-none d-sm-inline-flex justify-content-between text-xs px-1 align-items-center"
        >
          <i class="bi bi-folder2-open fs-5 me-2 "></i>
          Company <span class="px-1 text-x"> > </span><span class="fw-bold">{{ company_name }}</span>
        </span>
        <span
          v-else-if="user_role === 'Entity' && $route.name !== 'configure_company_management'"
          class="project-badge rounded-lg text-white ms-2 ms-md-5 d-none d-sm-inline-flex justify-content-between text-xs px-1 align-items-center"
        >
          <i class="bi bi-person fs-5 me-2"></i>
          Client <span class="px-1 text-x"> > </span><span class="fw-bold">{{ entity_name }}</span>
        </span>
      </a>
    </div>

    <!-- CENTER: GLOBAL SEARCH -->
    <div
      v-if="user_role === 'System Admin' || user_role === 'Entity' && $route.name !== 'configure_company_management'"
      class="d-none d-md-flex align-items-center w-25 mt-2"
    >
      <div class="position-relative input-group-sm flex-grow-1 text-white">
        <i class="bi bi-search position-absolute top-50 start-0 translate-middle-y ps-3 text-xs"></i>

        <input
          type="text"
          class="form-control form-control-sm ps-5 py-1 glass-card text-white shadow-lg mb-1 rounded-lg text-xxs"
          placeholder="Global Search"
          v-model="searchQuery"
          @input="handle_search_input"
          @focus="show_global_search = true"
        >

        <GlobalSearch
          ref="global_search"
          :show="show_global_search"
          :search-query="searchQuery"
          :project-id="project_id"
          :headers="headers"
          @close="show_global_search = false"
        />
      </div>
    </div>

    <!-- RIGHT SECTION -->
    <div class="d-flex align-items-center flex-nowrap gap-3">

      <!-- System Notifications MUST ALWAYS BE MOUNTED -->
      <SystemNotifications
        ref="system_notifications"
        :show="show_notifications"
        @close="show_notifications = false"
        @mark-all-read="update_unread_count(0)"
        @view-notification="handle_notification_click"
        @update-unread-count="update_unread_count"
      />

      <!-- Generate Self-Onboarding Link (hidden on configure_company_management) -->
      <template v-if="$route.name !== 'configure_company_management'">
        <a
          v-if="company_name === 'null'"
          class="btn btn-primary-dark disabled btn-sm rounded-small text-xxs shadow text-dark"
        >
          Generate Self-Onboarding link
        </a>

        <a
          v-else-if="user_role !== 'Entity' && company_name !== 'null'"
          class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
          data-bs-toggle="modal"
          data-bs-target="#create_new_user"
          @click="generate_share_link"
        >
          Generate Self-Onboarding link
        </a>
      </template>

      <!-- Notification Bell + Logout + Profile -->
      <div class="d-flex align-items-center gap-1">

        <!-- Notification Bell (hidden on configure_company_management) -->
        <template v-if="$route.name !== 'configure_company_management'">
          <a href="#" @click.prevent="toggle_notifications" class="position-relative">
            <i class="bi bi-bell me-2 fs-5 text-dark-white"></i>
            <span v-if="unread_notifications_count > 0" class="notification-badge">
              {{ unread_notifications_count > 9 ? '9+' : unread_notifications_count }}
            </span>
          </a>
        </template>

        <!-- LOGOUT ALWAYS VISIBLE -->
        <a class="me-2 text-xxs rounded-small" href="/" @click.prevent="logout">
          <i class="bi bi-box-arrow-right fs-5 text-white"></i>
        </a>

        <!-- Profile Dropdown (hidden on configure_company_management) -->
        <template v-if="$route.name !== 'configure_company_management'">
          <div class="dropdown">
            <i
              class="bi bi-person-circle fs-5 cursor-pointer text-dark-white"
            ></i>

            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <span class="dropdown-item-text text-xs">
                  {{ user_role || "User" }}
                </span>
              </li>
            </ul>
          </div>
        </template>

      </div>
    </div>
  </div>
</nav>

<AiconeLogo />

<!-- Modal -->
 <teleport to="body">
<div class="modal fade" id="create_new_user" tabindex="-1" aria-labelledby="create_user_label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs" id="create_user_label">Generate Self-Onboarding link</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <div class="modal-body">
        <p class="text-muted mb-3 text-xs">
          Share the link below to let entities register under your organisation:
        </p>

        <!-- Copy link -->
        <div class="input-group mb-3 text-xxs">
          <input
            type="text"
            class="form-control text-xs"
            v-model="share_link"
            readonly
          />
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs fw-bold text-dark"
            @click="copy_link"
          >
            Copy
          </button>
        </div>

        <!-- Email share -->
        <label class="text-muted text-xxs mb-1">Share via Email</label>

        <div class="input-group text-xxs">
          <input
            type="email"
            class="form-control text-xs"
            placeholder="Enter email address"
            v-model="share_email"
          />
          <button
            class="btn btn-primary-dark btn-sm rounded-small text-xxs fw-bold text-dark"
            @click="share_via_email"
          >
            Send
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
</teleport>

